import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { BRAND, purchaseNotice } from '../data/eatWellContent';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, []);
  return <AnimatePresence data-id="element-185" data-mp="2qvhvjgqa5div">
      {visible && <motion.aside initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Recent purchase" className="fixed bottom-24 left-4 z-30 hidden max-w-[19rem] items-start gap-3 border border-charcoal-600 bg-charcoal-900/95 px-4 py-3 shadow-card backdrop-blur lg:bottom-6 lg:flex" data-id="element-186" data-mp="2lvv9qiwdyoyg">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" strokeWidth={2} aria-hidden="true" data-id="element-187" data-mp="b3aga3hpeuli" />
          <div className="min-w-0" data-id="element-188" data-mp="1z52pkr0sxnqg">
            <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-champagne" data-id="element-189" data-mp="1z4155vxwbow2">
              Verified purchase
            </p>
            <p className="mt-1 text-[13px] leading-snug text-ivory-100" data-id="element-190" data-mp="2860m6o8wusz0">
              <span className="font-medium" data-id="element-191" data-mp="2846a7zfmab72">{purchaseNotice.name}</span> from{' '}
              {purchaseNotice.location} bought {BRAND}
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-192" data-mp="1fgtlpjpwbtb4">
              {purchaseNotice.minutesAgo} minutes ago
            </p>
          </div>
          <button type="button" onClick={() => setVisible(false)} className="-mr-1 -mt-1 shrink-0 p-1 text-muted transition-colors duration-150 ease-out hover:text-ivory-100" data-id="element-193" data-mp="1p7enfg0v9dy9">
            <XIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-194" data-mp="wqbzzz3hdxz9" />
            <span className="sr-only" data-id="element-195" data-mp="201ri1otl1wh6">Dismiss notification</span>
          </button>
        </motion.aside>}
    </AnimatePresence>;
}